import firebaseAdapter from "./firebaseAdapter";

export const { signIn, getAccessToken, watchSession, logout } = firebaseAdapter;

export default firebaseAdapter;
